export const USER_SUBSCRIBE_MUTATION = require('./userSubscribeMutation.graphql');
export const SET_MEMBER_CATEGORY_SUBSCRIPTIONS_MUTATION = require('./setMemberCategorySubscriptionsMutation.graphql');
export const SUBSCRIBE_TO_CATEGORY_MUTATION = require('./subscribeToCategoryMutation.graphql');
